import baseRoute from '../baseRoute';

export default `${baseRoute}/materialGroup` as const;
